import Model from "./model";

export default new Model({
  resource : "contrato",
  grouped : true,
  inputs:[
    {label:"ID", nameAttr:"id", default:null, required: true, type:"text", width: 60},
    {label:"Trabajador", nameAttr:"trabajador_id", default:null, required: true, type:"select", model:"trabajadorModel",searchPath:"nombre", width: 300},
    {label:"Campo", nameAttr:"campo_id", default:null, required: true, type:"select", model:"campoModel", searchPath: "nombre", width: 150},
    {label:"Descripción", nameAttr:"descripcion", default:"-", required: true, type:"text", width: 300},
    {label:"Valor Hora Extra", nameAttr:"hora_extra", default:0, required: true, type:"text", width: 100},
    {label:"Valor Día", nameAttr:"valor_dia", default:0, required: true, type:"text", width: 100},
    {label:"Tipo Contrato", nameAttr:"tipo_contrato_id", default:null, required: true, type:"select", model:"tipoContratoModel", searchPath: "nombre", width: 150},
  ]
});
